/**
 * Quiz Types
 * 
 * Type definitions for quiz-related tables in Supabase.
 */

export interface QuizUsage {
  id: string;
  user_id: string;
  notes_length: number;
  question_count: number;
  difficulty: string;
  model: string;
  input_tokens: number | null;
  output_tokens: number | null;
  estimated_cost_usd: number | null;
  created_at: string;
}

export interface QuizFeedback {
  id: string;
  quiz_usage_id: string;
  user_id: string;
  question_text: string;
  correct_answer: string;
  user_answer: string;
  explanation: string | null;
  is_positive: boolean;
  feedback_details: string | null;
  notes_context: string | null;
  created_at: string;
}

export interface QuizAttempt {
  id: string;
  user_id: string;
  quiz_usage_id: string | null;
  book_id: string | null;
  total_questions: number;
  correct_answers: number;
  score_percentage: number;
  difficulty: string;
  completed_at: string;
  created_at: string;
}

export interface QuizQuestion {
  id: string;
  quiz_usage_id: string;
  user_id: string;
  question_text: string;
  options: string[];
  correct_answer: string;
  explanation: string | null;
  question_order: number;
  created_at: string;
}

// Spaced repetition configuration
export const SPACED_REPETITION_INTERVALS = [
  1,   // Level 0: review tomorrow
  3,   // Level 1: review in 3 days
  7,   // Level 2: review in 1 week
  14,  // Level 3: review in 2 weeks
  30,  // Level 4: review in 1 month
  60,  // Level 5: review in 2 months
  120, // Level 6: review in 4 months
] as const;

export interface UserQuestionProgress {
  id: string;
  user_id: string;
  question_id: string;
  level: number;
  next_due_date: string;
  last_reviewed_at: string | null;
  times_correct: number;
  times_incorrect: number;
  created_at: string;
  updated_at: string;
}

export interface QuestionWithProgress extends QuizQuestion {
  progress?: UserQuestionProgress;
}
